import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import Section from '../Section';
import LazyLoad from 'react-lazyload';

const FeaturedInSection: React.FC = () => (
  <Section className="home-logos" md={12} lg={12}>
    <Row className="justify-content-center">
      <Col xs={12} md={8} className="text-center">
        <h2 className="small mb-3">Featured In:</h2>
      </Col>
    </Row>
    <Row style={{gap: '1rem'}} className="justify-content-center justify-content-md-between align-items-center">
      <a href="https://www.yahoo.com/lifestyle/7-rules-professional-house-cleaners-210000447.html" target='_blank'>
        <img style={{ maxWidth: '175px' }} src="https://res.cloudinary.com/twomaidsengi/image/upload/v1749480750/hubsite-reskin/Yahoo.webp" alt="Yahoo! Life" />
      </a>

      <a href="https://www.washingtonpost.com/home/2025/02/26/how-to-clean-kitchen-cabinets/" target='_blank'>
        <img style={{ maxWidth: '175px' }} src="https://res.cloudinary.com/twomaidsengi/image/upload/v1749480748/hubsite-reskin/washingtonPost.webp" alt="Washington Post" />
      </a>

      <a href="https://www.homesandgardens.com/solved/is-it-cheaper-to-make-or-buy-cleaning-products" target='_blank'>
        <img style={{ maxWidth: '175px' }} src="https://res.cloudinary.com/twomaidsengi/image/upload/v1749480748/hubsite-reskin/homesAndGardens.webp" alt="Homes & Gardens" />
      </a>

      <a href="https://www.bhg.com/items-cleaning-too-much-8775502" target='_blank'>
        <img style={{ maxWidth: '175px' }} src="https://res.cloudinary.com/twomaidsengi/image/upload/v1749480747/hubsite-reskin/betterHomesAndGardens.webp" alt="Better Homes & Gardens" />
      </a>

      <a href="https://www.marthastewart.com/things-you-never-clean-but-should-8772996" target='_blank'>
        <img style={{ maxWidth: '175px' }} src="https://res.cloudinary.com/twomaidsengi/image/upload/v1749480748/hubsite-reskin/marthaStewart.webp" alt="Martha Stewart" />
      </a>
    </Row>
  </Section>
);

export default FeaturedInSection;
